import React, { FC, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OrderYashakuSelectComponent } from '@component/index';
import { hideEcHeaderNavi } from '@app/react/common/Function';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import {
    apiGetActions,
    partsSelectActions,
} from '@app/react/action';
import { showOrderPartsHelpAction } from '@app/react/action/showOrderPartsHelp';
import type { AppState } from '@app/react/reducer';
import { IinitState } from '@app/react/reducer';
import { PartsProduct } from '@app/react/const/type';
import { useMediaDesktop, useMediaMobile } from '@app/react/common/useMedia';
import { selectOrderPartsHelp } from './selectors';

export const OrderYashakuSelectContainer: FC<{ waitFetch?: boolean }> = ({ waitFetch = false }) => {
    const dispatch = useDispatch();
    const { arrowType, orderType } = useOrderPathParams();
    const isDesktop = useMediaDesktop();
    const isMobile = useMediaMobile();

    const customizeData = useSelector<AppState, IinitState>(
        (state) => state.customize,
    );
    const alAdjust = useSelector<AppState, boolean>(
        (state) => state.customize.arrowlengthAdjust,
    );
    const arrowlength = useSelector<AppState, PartsProduct | null>(
        (state) => state.customize.arrowlength,
    );
    const partsData = useSelector<AppState, PartsProduct[]>(
        (state) => state.APIData.arrowlength?.partsData || [],
    );

    const openHelpParts = useSelector(selectOrderPartsHelp);
    const isOpenHelp = openHelpParts === 'arrowlength';

    const handleAdjust = (adjust: boolean | null) => {
        if (adjust === null) {
            return;
        }
        const params = adjust
            ? {
                adjust,
                arrowlength,
            }
            : {
                adjust,
                arrowlength: null,
            };

        dispatch(partsSelectActions.arrowlength.started(params));
    };

    const handleArrowlength = (al: PartsProduct) => {
        dispatch(
            partsSelectActions.arrowlength.started({
                adjust: true,
                arrowlength: al,
            }),
        );
    };

    const openHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: 'arrowlength' }));
    }, [dispatch]);

    const closeHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: null }));
    }, [dispatch]);

    useEffect(() => {
        hideEcHeaderNavi(isDesktop, isMobile, dispatch);
    }, [isDesktop, isMobile, dispatch]);

    useEffect(() => {
        if (waitFetch) {
            console.log('initializing, waiting fetch');
            return;
        }
        dispatch(
            apiGetActions.arrowlength.started({
                arrowType,
                orderType,
                selectItems: customizeData,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, arrowType, orderType, waitFetch]);

    return (
        <OrderYashakuSelectComponent
            adjust={alAdjust}
            onAdjust={handleAdjust}
            arrowlengths={partsData}
            arrowlength={arrowlength}
            onArrowlength={handleArrowlength}
            isHelpOpen={isOpenHelp}
            handleHelpOpen={openHelp}
            handleHelpClose={closeHelp}
        />
    );
};
